module.exports = __webpack_public_path__ + "img/ring_y_0_null_null@3x.63ffee12.png";